import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { IReduxState } from 'state-manager';


export const useAppSelector: TypedUseSelectorHook<IReduxState> = useSelector;
